import React from 'react';
import Button from './Button';

export default function EmptyState({ 
  icon: Icon,
  title, 
  description, 
  action,
  actionLabel,
  actionIcon
}) {
  return (
    <div className="empty-state animate-fade-in">
      {Icon && (
        <div className="mb-4 p-4 rounded-2xl bg-primary/5">
          <Icon className="w-12 h-12 text-primary/40" />
        </div>
      )}
      <h3 className="text-lg font-semibold text-text-primary">{title}</h3>
      <p className="mt-2 max-w-sm text-text-muted">{description}</p>
      {action && (
        <Button 
          onClick={action}
          icon={actionIcon}
          className="mt-6"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
